<section
  class="wrap"
  [ngClass]="isMobile ? !isActive ? 'collapsed' : 'expand' : isActive ? 'collapsed' : 'expand'">
  <a (click)="activeSidebar()" class="collapsed-left-btn" [ngClass]="isActive ? 'collapsed' : 'expand'">
    <img src="./assets/images/svg-icons/arrow-button.svg" alt=""
      class="arrow cursor-pointer" (click)="toggleDashboard()"
    />
  </a>
  <div class="sidebar-wrap">
    <a (click)="activeSidebar()" class="collapsed-right-btn mb-3" [ngClass]="!isActive ? 'collapsed' : 'expand'">
      <img src="./assets/images/svg-icons/arrow-nav-icon.svg" alt=""
        class="arrow cursor-pointer px-3" (click)="toggleDashboard()"/>
    </a>
    
    <div *ngIf="isMobile && isActive" class="close" (click)="isActive = false">
      <svg-icon src="./assets/images/svg-icons/close.svg"
              [svgStyle]="{ 'width.px': 16, 'height.px': 16 }"></svg-icon>
    </div>
    <div class="top d-flex justify-content-between mb-3">
      <a
        href="https://wsmcasino.com/"
        class="text-decoration-none d-flex align-items-center"
        title="{{ 'casino' | translate }}"
      >
        <svg-icon class="svg" src="./assets/images/sidebar/casino.svg" [svgStyle]="{ 'width.px': 20, 'height.px': 20 }"></svg-icon>
        <p class="font-14 m-0 ps-2" translate>casino</p>
      </a>
      <a
        href="https://www.wsmcasino.com/sports"
        class="text-decoration-none d-flex align-items-center"
        title="{{ 'sports' | translate }}"
      >
        <svg-icon class="fill" src="./assets/images/sidebar/sport.svg"></svg-icon>
        <p class="font-14 m-0 ps-2" translate>sports</p>
      </a>
    </div>

    <div class="list-wrapper">
      <!--==== 1st =====-->
      <div *ngFor="let item of list1">
        <a
          [href]="item.linkedUrl"
          title="{{ item.name | translate }}"
          class="menu-item text-decoration-none d-flex align-items-center py-2 px-3"
        >
          <svg-icon class="fill" [src]="item.img"></svg-icon>
          <p class="font-14 m-0 ps-2" translate>{{ item.name }}</p>
        </a>
      </div>
      <hr class="hr" />

      <!--==== 2nd =====-->
      <div *ngFor="let item of list2">
        <a
          [href]="item.linkedUrl"
          title="{{ item.name | translate }}"
          class="menu-item text-decoration-none d-flex align-items-center py-2 px-3"
        >
          <!-- <img [src]="item.img" alt="" /> -->
          <svg-icon [src]="item.img"></svg-icon>
          <p class="font-14 m-0 ps-2" translate>{{ item.name }}</p>
        </a>
      </div>
      <hr class="hr" />

      <!--==== 3rd =====-->
      <div>

        <a (click)="onTabSelect('vip-home')" title="{{'vip-sidenav' | translate}}"  class="menu-item text-decoration-none cursor-pointer d-flex align-items-center py-2 px-3">               
          <svg-icon src="./assets/images/sidebar/crown.svg" [svgStyle]="{ 'width.px': 25, 'height.px': 16 }"></svg-icon>
          <p [ngClass]="currentTab.includes('vip-home') ? 'active' : ''" class="font-14 m-0 ps-2" translate>vip-sidenav
          </p>
       </a> 

        <!-- <a  title="{{'wsm_dashboard' | translate}}" class="menu-item text-decoration-none d-flex align-items-center py-2 px-3" 
            routerLink="/{{currentLanguage}}" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
               <img src="./assets/images/sidebar/dashboard.svg" alt="">
               <p class="font-14  m-0 ps-2" translate>wsm_dashboard</p>
            </a> -->
        <a
          title="{{ 'wsm_dashboard' | translate }}"
          class="menu-item text-decoration-none d-flex align-items-center py-2 px-3"
          (click)="onTabSelect('dashboard')"
        >
          <svg-icon src="./assets/images/sidebar/dashboard.svg"></svg-icon>
          <p
            class="font-14 m-0 ps-2 cursor-pointer"
            [ngClass]="currentTab === 'dashboard' ? 'active' : ''"
            translate
          >
            wsm_dashboard
          </p>
        </a>

       

        <!-- <div class="coming-soon">
          <a
            title="{{ 'perps' | translate }}"
            class="menu-item text-decoration-none d-flex align-items-center py-2 px-3 cursor-default"
          >
            <img src="./assets/images/sidebar/future.svg" alt="" />
            <p class="font-14 m-0 ps-2" translate>
              perps<span class="" translate>coming_soon</span>
            </p>
          </a>
        </div>
        <div class="coming-soon">
          <a
          routerLink="/{{ currentLanguage }}/lootboxes"
            title="{{ 'lootboxes' | translate }}"
            class="menu-item text-decoration-none d-flex align-items-center py-2 px-3 cursor-default"
          >
            <img src="./assets/images/sidebar/lootbox.svg" alt="" />
            <p class="font-14 m-0 ps-2"  [ngClass]="currentTab.includes('lootboxes') ? 'active' : ''" translate>
              lootboxes<span class="" translate>coming_soon</span>
            </p>
          </a>
        </div> -->
        <!--<a  href="http://token.wallstmemes.com/"   -->
        <!-- <a routerLink="/{{currentLanguage}}/token" routerLinkActive="active"
               [routerLinkActiveOptions]="{exact: true}" title="{{'token' | translate}}"
               class="menu-item text-decoration-none d-flex align-items-center py-2 px-3">
               <img src="./assets/images/sidebar/token.svg" alt="">
               <p class="font-14  m-0 ps-2" translate>token</p>
            </a> -->
        <a
          routerLink="/{{ currentLanguage }}/token{{ bwUrl }}"
          title="{{ 'token' | translate }}"
          (click)="onTabSelect('token')"
          class="menu-item text-decoration-none d-flex align-items-center py-2 px-3"
        >
          <svg-icon src="./assets/images/sidebar/token.svg"></svg-icon>
          <p
            [ngClass]="currentTab.includes('token') ? 'active' : ''"
            class="font-14 m-0 ps-2"
            translate
          >
          wsm_token
            <!-- <svg-icon src="./assets/images/svg-icons/arrow-down.svg"
                  [svgStyle]="{ 'width.px':14, 'height.px':14 }" class="submenuOpt"
                  [ngClass]="tokenSubMenuOpened ?'subMenuOpened' : 'subMenuClosed'"></svg-icon> -->
          </p>
        </a>
        <a *ngIf="!isProd" (click)="onTabSelect('leaderboard')" title="{{'leaderboard' | translate}}"  class="menu-item text-decoration-none cursor-pointer d-flex align-items-center py-2 px-3">               
          <svg-icon src="./assets/images/sidebar/leaderboar-icon.svg"></svg-icon>
          <p [ngClass]="currentTab.includes('leaderboard') ? 'active' : ''" class="font-14 m-0 ps-2" translate>leaderboard
          </p>
        </a>
        <!-- <ul class="subMenu" [ngClass]="{'foldMe': !tokenSubMenuOpened }">
            <li class="py-2">
              <a class="p-0 d-flex justify-content-start align-items-center cursor-pointer"
                   href="https://linktr.ee/wallstmemes" target="_blank">
                <span class="" translate>meme_followers</span>
              </a>
            </li>
            <li class="py-2">
               <a class="p-0 d-flex justify-content-start align-items-center cursor-pointer"
                  (click)="navigateToFragment('burnToken')" [ngClass]="currentTab.includes('burnToken') ? 'active' : ''">
                 <span class="" translate>burn</span>
               </a>
             </li>
             <li class="py-2">
               <a class="p-0 d-flex justify-content-start align-items-center cursor-pointer"
                  (click)="navigateToFragment('howtoBuy')" [ngClass]="currentTab.includes('howtoBuy') ? 'active' : ''">
                 <span class="" translate>how_to_buy</span>
               </a>
             </li>
          </ul> -->
      </div>
      <hr class="hr" />

      <!--==== 4th =====-->
      <div *ngFor="let item of list3">
        <a
          class="menu-item text-decoration-none d-flex align-items-center py-2 px-3"
          [href]="item.linkedUrl"
          title="{{ item.name | translate }}"
        >
          <svg-icon [src]="item.img"></svg-icon>
          <p class="font-14 m-0 ps-2" translate>{{ item.name }}</p>
        </a>
      </div>

      <a
        class="menu-item text-decoration-none d-flex align-items-center py-2 px-3"
        (click)="disconnect()"
        *ngIf="walletAddress && isMobile"
        title="Disconnect"
      >
        <img src="./assets/images/svg-icons/disconnected.svg" alt="" />
        <p class="font-14 m-0 ps-2">{{ walletAddress | trimAddress }}</p>
      </a>

      <a
        class="menu-item text-decoration-none d-flex align-items-center py-2 px-3"
        (click)="connectModal()"
        *ngIf="!walletAddress && isMobile && !showBW"
        title="Disconnect"
      >
        <img src="./assets/images/svg-icons/connected-dot.svg" alt="" />
        <p class="font-14 m-0 ps-2">{{ "connect_wallet" | translate }}</p>
      </a>
      <a
        class="menu-item text-decoration-none d-flex align-items-center py-2 px-3"
        (click)="connectBestWallet()"
        *ngIf="!walletAddress && isMobile && showBW"
        title="Disconnect"
      >
        <img src="./assets/images/svg-icons/connected-dot.svg" alt="" />
        <p class="font-14 m-0 ps-2">{{ "connect_bw" | translate }}</p>
      </a>
      <!-- <div class="mx-auto px-3" *ngIf="isMobile">
            <a href=""> <button class="login">Login</button></a>
            <a href=""> <button class="login ms-3 bg-black text-white">Anmeldung</button></a>
          </div> -->
    </div>
  </div>
</section>
